<template>
  <div class="flex">
    <MainMenu class="side-menu" :selectTab="selectTab" :admin_fit20="this._data" :fit20="fit20"></MainMenu>
    <Content class="content" :fit20="fit20" :selectTab="selectTab" :admin_fit20="this._data" :formatDate="formatDate">
    </Content>
  </div>
</template>

<script>
import MainMenu from './MainMenu';
import Content from './Content.vue';
export default {
  name: 'Admin',
  components: {
    MainMenu,
    Content
  },
  props: ["selectTab", "fit20", "formatDate"],
  data() {
    return {
      studio: {},
      machines: [],
      machine: {},
      members: [],
      member: {},
      users: [],
      user: {}
    };
  },
  async created() {
    console.log("start feting machine")
    this.selectTab('#admin_studios');
    const getAllMachines = await fetch(this.fit20.baseUrl + "/api/machines?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
    this.machines = await getAllMachines.json();
  },
};
</script>

<style>
.admin-header-container {
  height: 130px;
  background-color: white;
}

.admin-header {
  height: 130px;
  width: 75%;
  padding-right: 20px;
  background-color: white;
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  z-index: 99;
}

.admin-header .img-container {
  text-align: right;
}

.admin-header-sec {
  padding: 10px 5px;
}

.admin-title-sec {
  color: var(--fit20-blue);
}

.side-menu {
  width: 25%;
}

.content {
  width: 75%;
}
</style>
